module.exports = __webpack_public_path__ + "static/media/Rectangulo 71@2x.4cf717e3.png";